import { FC } from 'react';
import { FLAG_GUEST_AMEND_ENABLED } from 'config/env';
import EditButtonWithIcon from './components/EditButtonWithIcon';
import { SelfServiceAPI } from 'types';
import * as tracking from 'lib/gaTracking/bookingDetailsPageEvents';

interface EditButtonProps {
  booking: SelfServiceAPI.Booking;
  openModal: () => void;
}

const EditButton: FC<EditButtonProps> = ({ booking, openModal, ...rest }) => {
  if (!FLAG_GUEST_AMEND_ENABLED) {
    return null;
  }

  const {
    flags: { isBooked, isChangeInProgress, isFinalising },
  } = booking;

  if (!isBooked || isChangeInProgress || isFinalising) {
    return null;
  }

  const handleClick = () => {
    tracking.editDetailsPopUp('Link Selected');
    openModal();
  };

  return <EditButtonWithIcon {...rest} onClick={handleClick} />;
};

export default EditButton;
